<callcard-detail-home *ngIf="callcard && page == 0" [callcard]="callcard"></callcard-detail-home>
<app-callcard-journal *ngIf="callcard && page == 1" [callcard]="callcard"></app-callcard-journal>
